import React from 'react'
import { Redirect, useParams } from 'react-router-dom'

import { editorials } from './articles'
import { EditorialTemplate } from './editorial-template'

interface EditorialRouteParams {
  slug: string
}

const EditorialPage = () => {
  const { slug } = useParams<EditorialRouteParams>()
  const editorial = editorials.find((article) => article.slug === slug)

  if (!editorial) {
    return <Redirect to="/madetowear" />
  }

  return (
    <EditorialTemplate
      label={editorial.label}
      title={editorial.title}
      subtitle={editorial.subtitle}
    >
      {editorial.content}
    </EditorialTemplate>
  )
}

export default EditorialPage
